import { useContext, useEffect } from "react";

import { hotjar } from "react-hotjar";

import AuthContext from "context/auth/authContext";
import { getEnvironment, isAnalyticsCookieAccepted } from "shared/functions";

export const useHotjar = () => {
    const { cookieConsent } = useContext(AuthContext);

    const { isNotLocalEnv } = getEnvironment();

    const hotjarId = Number(import.meta.env.VITE_HOTJAR_ID);

    useEffect(() => {
        isNotLocalEnv &&
            isAnalyticsCookieAccepted(cookieConsent) &&
            hotjar.initialize({ id: hotjarId, sv: 6 });
    }, [hotjarId, isNotLocalEnv, cookieConsent]);
};
